import { Flex, Input, InputGroup, InputLeftAddon } from '@chakra-ui/react'
import { useEffect, useState } from 'react'

import { FormField } from '../../../../components/FormField'
import { FormModal } from '../../../../components/FormModal'
import { useAppToast } from '../../../../helpers'
import {
  ICreateUpdateUrlRedirectorPayload,
  IUrlRedirector,
  UrlRedirectorService
} from '../../../../services/UrlShortener/UrlRedirectorService'

interface IForm {
  from: string
  to: string
}

interface IUrlRedirectorCreateModalProps {
  isOpen: boolean
  onClose: () => void
  initialData?: Partial<IUrlRedirector>
}

export function UrlRedirectorCreateModal({ isOpen, onClose, initialData }: IUrlRedirectorCreateModalProps) {
  const service = new UrlRedirectorService()
  const toast = useAppToast()
  const [form, setForm] = useState<IForm>({} as IForm)
  const [formErrors, setFormErrors] = useState<Record<string, string>>({})
  const [saving, setSaving] = useState(false)

  useEffect(() => {
    if (initialData) {
      // Modo cópia - pré-preencher com dados iniciais e adicionar sufixo "_copia"
      setForm({
        from: initialData.from ? `${initialData.from}_copia` : '',
        to: initialData.to || ''
      })
    } else {
      // Modo criação normal - campos vazios
      setForm({
        from: '',
        to: ''
      })
    }
    setFormErrors({})
  }, [isOpen, initialData])

  const handleToInputChange = (value: string) => {
    // Simplesmente atualiza o valor conforme o usuário digita
    setForm({ ...form, to: value })
  }

  const handleToInputBlur = (value: string) => {
    // Quando o usuário sai do campo, adiciona https:// se necessário
    if (value && !value.match(/^https?:\/\//)) {
      setForm({ ...form, to: `https://${value}` })
    }
  }

  const handleSave = async () => {
    setSaving(true)
    setFormErrors({})
    try {
      await service.create({
        from: form.from,
        to: form.to
      } as ICreateUpdateUrlRedirectorPayload)

      toast.success('Redirecionador de URL criado com sucesso')

      onClose()
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error: any) {
      if (error.response?.status === 400) setFormErrors(error.response.data.errors)
      else toast.error('Erro ao criar o Redirecionador de URL', error)
    } finally {
      setSaving(false)
    }
  }

  return (
    <FormModal
      isOpen={isOpen}
      onClose={onClose}
      title="Criar redirecionador de URL"
      onSubmit={handleSave}
      confirmLabel="Criar"
      isLoading={saving}
    >
      <Flex direction="column">
        <FormField label="De" error={formErrors.from} isRequired>
          <InputGroup>
            <InputLeftAddon>https://abra.com.br</InputLeftAddon>
            <Input value={form.from} disabled={saving} onChange={(e) => setForm({ ...form, from: e.target.value })} />
          </InputGroup>
        </FormField>
        <FormField label="Para" error={formErrors.to} isRequired mt={4}>
          <Input
            value={form.to}
            disabled={saving}
            onChange={(e) => handleToInputChange(e.target.value)}
            onBlur={(e) => handleToInputBlur(e.target.value)}
            type="url"
          />
        </FormField>
      </Flex>
    </FormModal>
  )
}
